import React, { createContext, useState } from 'react';
import { Stack, Typography, useTheme, alpha } from '@mui/material';
import { Switch, Card } from '@repo/ui'

export const DevToolsContext = createContext(null);

interface Props {
  children: React.ReactNode
}

// Hide the floating Dev Tools toggle for now (component kept intact — flip back
// to true to restore the on-screen pill). The provider + context still work, so
// any `devToolsEnabled` consumers are unaffected.
const SHOW_DEV_TOOLS_TOGGLE = false;

export const DevToolsProvider = ({ children }: Props) => {
  const theme = useTheme();
  const [devToolsEnabled, setDevToolsEnabled] = useState(true);

  const contextValue = {
    devToolsEnabled,
    setDevToolsEnabled,
  };

  const showWidget = import.meta.env.VITE_ENVIRONMENT === 'development' && import.meta.env.VITE_DEV_TOOLS === 'true'

  return (showWidget ? (
    <DevToolsContext.Provider value={contextValue}>
      {children}
      {SHOW_DEV_TOOLS_TOGGLE && (
      <div style={{ position: 'fixed', bottom: '12px', right: '72px', zIndex: 1000}}>
        <Stack style={{padding: '0px', borderRadius: '50px', background: theme.palette.background.default,}}>
          <Stack direction="row" alignItems="center" gap={2} style={{
              borderRadius: '50px',
              padding: '12px 16px 12px 16px',
              background: devToolsEnabled ? alpha(theme.palette.brand[500], 0.1) : theme.palette.background.default,
              border: devToolsEnabled ? `1px solid ${theme.palette.brand[500]}` : `1px solid ${theme.palette.grey[300]}`,
            }}>
            <Typography variant="body" fontWeight="semibold" color={devToolsEnabled ? theme.palette.brand[500] : theme.palette.text.primary}>Dev Tools:</Typography>
            <Switch defaultChecked={devToolsEnabled} onChange={() => setDevToolsEnabled(devToolsEnabled => !devToolsEnabled)} />
          </Stack>
        </Stack>
      </div>
      )}
    </DevToolsContext.Provider>
  ) : (
    <>
      {children}
    </>
  ))
};